<template>
  <div>
    <v-data-iterator
      :items="helpBook"
      class="profit"
      content-tag="div"
      :content-class="'layout row wrap'"
      hide-actions >
      <template slot="header">
        <v-toolbar class="mb" color="primary" dark  flat>
            <v-toolbar-title>
                <router-link to="/Dashboard">
                    <b class="white--text font-weight-light">HELP_BOOK</b> 
                </router-link>
            </v-toolbar-title>
        </v-toolbar>
      </template>

      <template slot="item" slot-scope="props">
        <v-flex  style=" display: flex;flex-direction: column;" xs6 md6 sm6 v-if="props.item.expense">
          <v-card>
            <v-card-title class="primary white--text">
              <h3><span class="print-field">ACTION</span></h3>
              <v-spacer/>
              <h3><span class="print-field"> SHORTCUT </span></h3>
            </v-card-title>
          </v-card>
          
          <v-card>
            <v-card-title>
              <h3><span class="print-field">1. Dashboard</span></h3>
              <v-spacer />
              <h3><span class="print-field">alt + a</span></h3>
            </v-card-title>
            <v-card-title>
              <h3><span class="print-field">2. Buyer</span></h3>
              <v-spacer />
              <h3><span class="print-field">alt + b</span></h3>
            </v-card-title>
            <v-card-title>
              <h3><span class="print-field">3. Reports</span></h3>
              <v-spacer />
              <h3><span class="print-field">alt + z </span></h3>
            </v-card-title>
            <v-card-title>
              <h3><span class="print-field">4. Transactions</span></h3>
              <v-spacer />
              <h3><span class="print-field">alt + t</span></h3>
            </v-card-title>
            <v-card-title>
              <h3><span class="print-field">5. Setting</span></h3>
              <v-spacer />
              <h3><span class="print-field">alt + s</span></h3>
            </v-card-title>
            <v-card-title>
              <h3><span class="print-field">6. Information</span></h3>
              <v-spacer />
              <h3><span class="print-field">alt + r</span></h3>
            </v-card-title>
            <v-card-title>
              <h3><span class="print-field">7. New Product</span></h3>
              <v-spacer />
              <h3><span class="print-field">alt + p</span></h3>
            </v-card-title>
            <v-card-title>
              <h3><span class="print-field">8. Product List </span></h3>
              <v-spacer />
              <h3><span class="print-field">alt + a</span></h3>
            </v-card-title>
          </v-card>
        </v-flex>
        
        <v-flex  style=" display: flex;flex-direction: column;" xs6 md6 sm6 v-if="!props.item.expense">
          <v-card>
            <v-card-title class="primary white--text">
              <h3><span class="print-field">ACTION</span></h3>
              <v-spacer/>
              <h3><span class="print-field"> SHORTCUT </span></h3>
            </v-card-title>
          </v-card>
          
          <v-card>
            <v-card-title>
              <h3><span class="print-field">1. New Invoice</span></h3>
              <v-spacer />
              <h3><span class="print-field">alt + i</span></h3>
            </v-card-title>
            <v-card-title>
              <h3><span class="print-field">2. New Receipt</span></h3>
              <v-spacer />
              <h3><span class="print-field">alt + r</span></h3>
            </v-card-title>
            <v-card-title>
              <h3><span class="print-field">3. Manage Order</span></h3>
              <v-spacer />
              <h3><span class="print-field">alt + o</span></h3>
            </v-card-title>
            <v-card-title>
              <h3><span class="print-field">4. Manage Estimate</span></h3>
              <v-spacer />
              <h3><span class="print-field">alt + e</span></h3>
            </v-card-title>
            <v-card-title>
              <h3><span class="print-field">5. Manage Portfolio</span></h3>
              <v-spacer />
              <h3><span class="print-field"> * </span></h3>
            </v-card-title>
            <v-card-title>
              <h3><span class="print-field">6. Manage Godown</span></h3>
              <v-spacer />
              <h3><span class="print-field">alt + g</span></h3>
            </v-card-title>
            <v-card-title>
              <h3><span class="print-field">7. Day Book</span></h3>
              <v-spacer />
              <h3><span class="print-field">alt + a</span></h3>
            </v-card-title>
            <v-card-title>
              <h3><span class="print-field">8. Cash Book</span></h3>
              <v-spacer />
              <h3><span class="print-field">alt + a</span></h3>
            </v-card-title>
            <v-card-title>
              <h3><span class="print-field">9. Bank Book</span></h3>
              <v-spacer />
              <h3><span class="print-field"> * </span></h3>
            </v-card-title>
            <v-card-title>
              <h3><span class="print-field">10. Financial Book</span></h3>
              <v-spacer />
              <h3><span class="print-field"> * </span></h3>
            </v-card-title>
          </v-card>
        </v-flex> 
      </template>
    </v-data-iterator>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
import ExpandCard from '../Balancesheet/expandCard';
import {convertToCashBook } from "../../../utils/pdf-reports/information-reports";
const mapGlobalGetters = createNamespacedHelpers('Global')['mapGetters']

  export default {
    components: {
      ExpandCard,
    },
    data: () => ({
       helpBook: [
        {
          expense: true
        },
        {
          expense: false
        },
      ],
    }),
    created() { },
    computed: { },
    watch:{ },
    methods:{ }
  }
</script>
<style>
.v-data-iterator.profit .v-expansion-panel__header__icon {
  display: none;
}
.v-data-iterator.profit .v-expansion-panel__header {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Informations/HelpBook/helpBook.vue